var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicro = function SvgMicro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#8B9CAC",
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FBFD",
    d: "M27 27H9v-2h.9V10c0-.265.095-.52.264-.707A.857.857 0 0 1 10.8 9h12.6c.239 0 .468.105.636.293.17.187.264.442.264.707v5h1.8v10h.9v2Zm-4.5-2h1.8v-8h-5.4v8h1.8v-6h1.8v6Zm0-10v-4H11.7v14h5.4V15h5.4Zm-9 2h1.8v2h-1.8v-2Zm0 4h1.8v2h-1.8v-2Zm0-8h1.8v2h-1.8v-2Z"
  })));
};
export default SvgMicro;